import { combineReducers } from "redux";

import Login from "./Login";
const Reducers = combineReducers({

    Login,

});
export default Reducers;
